import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../common/Controller';
import { CommonStyles } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import { ColourPalette } from '../styles/AppColourPalette';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';

export class Tiles extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    if (this.props.items.length === 0) {
      return (<p>Nothing to show here</p>)
    }

    return (
      <div className={css(Styles.innerContainer)}>
        <Grid container spacing={4}>
          {this.props.items.map(item => {
            return (
              <Grid item xs={12} sm={4} md={3} className={css(Styles.tileContainer)}>
                <div className={css(Styles.tileContent)} onClick={(e) => this.props.onRowItemClick(item)}>
                  <div className={css(Styles.ImgOuterContainer)}>
                    {item.logoUrl &&
                      <img
                        src={item.logoUrl}
                        onError={(e) => {
                          e.target.src = require('../assets/images/error.svg')
                        }} className={css(Styles.ImgContent)} />
                    }
                    {!item.logoUrl &&
                      <Icon
                        className={css(Styles.defaultIcon)}>
                        {this.props.defaultIcon}
                      </Icon>
                    }
                  </div>
                  <div className={css(Styles.tileDetailContainer)}>
                    <p className={css(Styles.tileDetailContainerName)}>{item.name}</p>
                    <div aria-describedby={this.props.id} onClick={(e) => this.props.editClick(e, item)} className={css(Styles.editContent)} >
                      <img src={require('../assets/images/more-rounded.svg')} />
                    </div>
                  </div>

                </div>
              </Grid>
            )
          })}
        </Grid>
      </div>
    )
  }
}


const Styles = StyleSheet.create({
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 65,
    marginBottom: 50
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  tileContent: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0 10px 10px 10px',
    backgroundColor: AppTheme.secondaryColor,
    position: 'relative',
    border: '2px solid' + AppTheme.secondaryColor,
    cursor: 'pointer',
  },
  ImgOuterContainer: {
    width: '100%',
    height: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBackground,
    borderRadius: '0px 10px 0px 0px'
  },
  ImgContent: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '0px 10px 0px 0px'
  },
  editContent: {
    cursor: 'pointer',
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: AppTheme.primaryBackground,
    }
  },
  tileDetailContainer: {
    display: 'flex',
    padding: 15,
    alignItems: 'center',
    backgroundColor: '#1E2530',
    borderRadius: '0px 0px 10px 10px'
  },
  tileDetailContainerName: {
    color: AppTheme.white,
    opacity: 0.7,
    fontSize: AppTheme.fontSizeTitle,
    margin: 0,
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  defaultIcon: {
    fontSize: 100,
    color: ColourPalette.color1,
  }
})



// WEBPACK FOOTER //
// ./src/components/Tiles.js